module.exports = __webpack_public_path__ + "static/media/party-catering-4.96830447.jpg";